import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './assets/logo.svg'
import _imports_1 from './assets/screenshot_1.png'
import _imports_2 from './assets/screenshot_2.png'


const _withScopeId = n => (_pushScopeId("data-v-d70e991c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "root" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "notify",
    class: "logo",
    src: _imports_0
  }),
  /*#__PURE__*/_createElementVNode("label", { class: "title" }, "NotifyHub - Your Notification Center"),
  /*#__PURE__*/_createElementVNode("label", { class: "subtitle" }, "You define what need to be notified")
], -1))
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"screenshot\" data-v-d70e991c><img src=\"" + _imports_1 + "\" data-v-d70e991c><img style=\"margin-left:-1px;\" src=\"" + _imports_2 + "\" data-v-d70e991c></div><div class=\"footer\" data-v-d70e991c><a class=\"warning-label\" href=\"mailto:abctwiq@163.com\" data-v-d70e991c>Feedback &amp; Contact</a><label class=\"copy-right\" data-v-d70e991c>@2021</label></div>", 2)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("label", {
      class: "download",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onInstall && _ctx.onInstall(...args)))
    }, " Download "),
    _hoisted_3
  ]))
}